import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Fa from 'react-fontawesome';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

import NumberDisplay from '../../../../components/number-display';

class ContactRenderer extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.showEditProduct = this.showEditProduct.bind(this);
  }

  showEditProduct(e) {
    e.preventDefault();
    e.stopPropagation();
    const { disabled } = this.props;
    if (!disabled) {
      this.props.requestshowEditContacts(this.props.selectedOpportunity);
      return false;
    }
  }

  render() {
    const {
      loaded, isSelected, allSubmitted,
      selectedProductCount, availableProductCount, totalProductCount,
      data,
    } = this.props;
    if (!loaded) {
      return (<Fa name="spinner" spin className="text-muted" />);
    }
    if (loaded && !allSubmitted) {
      let comp = null;
      if (!isSelected) {
        return (
          <span>Available: <NumberDisplay value={availableProductCount} precision={0} /></span>
        );
      } else if (selectedProductCount > 0) {
        comp = (
          <span>
            {'Selected: '}
            <span className="text-active"><NumberDisplay value={selectedProductCount} precision={0} /></span>
            {' | Available: '}
            <NumberDisplay value={availableProductCount} precision={0} />
          </span>
        );
      } else if (selectedProductCount === 0) {
        const emptyProductTooltip = (
          <Tooltip id={`empty-product-tip-${data._id}`}>
            <div>Select the primary product to gather feedback on to submit this opportunity to TruVoice.</div>
          </Tooltip>
        );
        comp = (
          <OverlayTrigger placement="top" overlay={emptyProductTooltip}>
            <span className="text-danger">
              <Fa name="exclamation-triangle" className="text-danger" />
              {' Select 0 | Available: '}
              <NumberDisplay value={availableProductCount} precision={0} />
            </span>
          </OverlayTrigger>
        );
      }
      return (
        <a
          href=""
          onClick={this.showEditProduct}
        >
          {comp}
        </a>
      );
    }

    return null;
  }
}

ContactRenderer.propTypes = {
  data: PropTypes.shape({
    _id: PropTypes.string,
  }),
  selectedOpportunity: PropTypes.shape({}),
  loaded: PropTypes.bool,
  totalProductCount: PropTypes.number,
  availableProductCount: PropTypes.number,
  selectedProductCount: PropTypes.number,
  isSelected: PropTypes.bool,
  disabled: PropTypes.bool,
  allSubmitted: PropTypes.bool,
  requestshowEditContacts: PropTypes.func,
};
ContactRenderer.defaultProps = {
  data: null,
  selectedOpportunity: null,
  loaded: false,
  totalProductCount: 0,
  selectedProductCount: 0,
  availableProductCount: 0,
  isSelected: false,
  disabled: false,
  allSubmitted: false,
  requestshowEditContacts: () => {},
};

export default ContactRenderer;
